import { render, staticRenderFns } from "./fileAttribute.vue?vue&type=template&id=45f1bb7f&scoped=true"
import script from "./fileAttribute.vue?vue&type=script&lang=js"
export * from "./fileAttribute.vue?vue&type=script&lang=js"
import style0 from "./fileAttribute.vue?vue&type=style&index=0&id=45f1bb7f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f1bb7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f1bb7f')) {
      api.createRecord('45f1bb7f', component.options)
    } else {
      api.reload('45f1bb7f', component.options)
    }
    module.hot.accept("./fileAttribute.vue?vue&type=template&id=45f1bb7f&scoped=true", function () {
      api.rerender('45f1bb7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/fileAttribute.vue"
export default component.exports